export default {
  props: ['value', 'disabled', 'accept', 'error'],
  methods: {
    handleImage (event) {
      if (this.disabled) {
        return
      }
      let files = event.target.files
      if (files.length === 0) {
        return
      }
      let reader = new FileReader()
      this.preview = event.target.files[0].name
      this.error = null
      reader.onload = (event) => {
        this.$emit('input', files[0])
      }
      reader.readAsDataURL(files[0])
    }
    // remove () {
    //   this.$emit('remove')
    // }
  },
  data () {
    return {
      hovering: false,
      preview: null
    }
  },
  computed: {
    backgroundImage () {
      let image = this.preview || this.value
      if (!image) {
        return image
      }
      return image
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/upload-file/upload-image.component.js